import { render, staticRenderFns } from "./CardDark.vue?vue&type=template&id=28d27c14&"
import script from "./CardDark.vue?vue&type=script&lang=js&"
export * from "./CardDark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports